export { default, type MenuProps } from './Menu';
